/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    routeName: {
        home: 'home',
        projectManagement: "projectManagement",
        moreProjectManagement: "moreProjectManagement",
        memberServices: "memberServices",
        membershipDues: "membershipDues",
        paymentManagement: 'paymentManagement',
        excellenceScore: "excellenceScore",
        realNameEmployManage: "realNameEmployManage",
        eventManagement: "eventManagement",
        syzj: "syzj",
        ssfgd: "ssfgd",
        gdsyzj: "gdsyzj",
        gdsyzjgj: "gdsyzjgj",
        gdsyzzsj: "gdsyzzsj",
        gdslssgj: "gdslssgj",
        gdsszsfj: "gdsszsfj",
        gdsszyzj: "gdsszyzj",
        gmxmsb: "gmxmsb",
        sgwfgd: "sgwfgd",
        syzj_member: "syzj_member",
        ssfgd_member: "ssfgd_member",
        gdsyzj_member: "gdsyzj_member",
        gdsyzjgj_member: "gdsyzjgj_member",
        gdsyzzsj_member: "gdsyzzsj_member",
        gdslssgj_member: "gdslssgj_member",
        gdsszsfj_member: "gdsszsfj_member",
        gdsszyzj_member: "gdsszyzj_member",
        gmxmsb_member: "gmxmsb_member",
        sgwfgd_member: "sgwfgd_member",
        memberManagement: 'memberManagement',
        expertManagement: "expertManagement",
        personal: 'personal',
        message: 'message',
        download: 'download',
        projectApplication: "projectApplication",
        User: 'User',
        menu: 'menu',
        role: 'role',
        configuration: 'configuration',
        speciality: 'speciality',
        integral: 'integral',
        memberNature: 'memberNature',
        review: 'review',
        excellenceScoreCfg: "excellenceScoreCfg",
        excellenceScoreCfg: "excellenceScoreCfg",
        ProjectNumber: "ProjectNumber",
        examine: 'examine',
        examineList: 'examineList',
        examineDefine: 'examineDefine',
        memberApplication: "memberApplication",
        paymentDeclaration: "paymentDeclaration",
        expertApplication: "expertApplication",
        examineProject: "examineProject",
        log:"log",
        Template:"Template"
    },
    ...enLocale //  合并element-ui内置翻译
}

export default en


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js